var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmerican(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3086C8",
    d: "M2.339 0c-1.292 0-2.339.914-2.339 2.042v19.916c0 1.128 1.047 2.042 2.339 2.042h33.159c1.382 0 2.502-.914 2.502-2.042v-19.916c0-1.128-1.12-2.042-2.502-2.042h-33.159zm15.104 13.305l-1.538-3.275h-2.078v4.718l-2.087-4.718h-1.664l-2.213 4.944h1.299l.491-1.232h2.509l.498 1.226h2.464v-3.7l1.747 3.709h1.143l1.595-3.648v3.652h1.489v-4.951h-2.113l-1.542 3.275zm-7.315-.611l.75-1.656.781 1.656h-1.531zm17.224-1.087l-1.401-1.576h-3.997v4.934h3.836l1.516-1.595 1.481 1.606h1.14v-.476l-1.783-2.023 1.783-1.893v-.559h-1.128l-1.447 1.582zm-2.222 2.34h-1.894v-1.027h1.785v-.85h-1.785v-1.011l2.054.006 1.229 1.412-1.389 1.47zm5.87-3.231l-1.709 1.784 1.709 1.784v1.716h-1.073v-.001h-1.671l-.909-1.064-.972 1.064h-4.845v.001h-2.564v-.047h-.022v-.526l-.262.571h-2.265l-.284-.61v.61h-4.233l-.501-1.23h-.848l-.529 1.23h-2.167v.002h-.855v-1.853l.855-1.647v.004l1.581-3.503h3.08l.432.994v-.986h3.769l.829 1.674.81-1.681h2.961v-.002h.427v.001h-.427v.019h5.155l.949 1.031.972-1.031h1.534v-.02h1.073v1.716z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmerican);
export default __webpack_public_path__ + "static/media/american.2d53cbb9c380a23b7633ad163dc83bb4.svg";
export { ForwardRef as ReactComponent };